import React, {useState, useRef, useEffect} from 'react';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import UndoIcon from '@material-ui/icons/Undo';
import Avatar from '@material-ui/core/Avatar';
import {useTranslation} from 'react-i18next';

import Conf from 'utils/Conf';
import './Chat.scss';

const ChatMessage = ({onEdit, onValidate, onDelete, from, body, isLeft, delay, className}) => {
  const {t} = useTranslation();
  const [hover, setHover] = useState(false);
  const [bodyEdition, setBodyEdition] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const editInput = useRef(null);

  useEffect(() => {
    if (isEditing) editInput.current.focus();
  }, [isEditing]);

  const handleStartEdit = () => {
    setBodyEdition(body || '');
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setBodyEdition('');
  };

  const handleValidate = () => {
    if (!isEditing) return onValidate();
    setIsEditing(false);
    onValidate(bodyEdition);
    setBodyEdition('');
  };

  const renderSender = () => {
    if (!from) return t('spectateur');
    if (typeof from === 'string') return from;
    if (from.cinema && from.city) {
      return `${t('name-from-cinema', {name: from.name, cinema: from.cinema})} - ${from.city}`;
    }
    return from.name;
  };

  //eslint-disable-next-line
  const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  const renderTextWithLink = txt =>
    txt.split(' ').map(part =>
      URL_REGEX.test(part) ? (
        <a target="_blank" rel="noopener noreferrer" href={part}>
          {part}{' '}
        </a>
      ) : (
        part + ' '
      ),
    );

  const renderActions = () => {
    return (
      <div className={classNames('chat', 'edit-btn', className)}>
        {isEditing && (
          <IconButton aria-label="cancel edition" color="primary" onClick={handleCancelEdit}>
            <UndoIcon fontSize="small" />
          </IconButton>
        )}
        {!isEditing && hover && (onEdit || onValidate) && (
          <IconButton aria-label="edit" color="primary" onClick={onEdit || handleStartEdit}>
            <EditIcon fontSize="small" />
          </IconButton>
        )}
        {(isEditing || hover) && onValidate && (
          <IconButton aria-label="validate" color="primary" onClick={handleValidate}>
            <SendIcon fontSize="small" />
          </IconButton>
        )}
        {(isEditing || hover) && onDelete && (
          <IconButton aria-label="delete" color="secondary" onClick={onDelete}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </div>
    );
  };

  return (
    <div
      className={classNames('chat-card', className, {left: isLeft, right: !isLeft}, `delay-${delay}`)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className={classNames('chat', 'sender', className)}>
        {isLeft && from && from.photo && (
          <Avatar
            alt={renderSender()}
            src={`${Conf.assetsRoot}${from.photo}`}
            className={classNames('chat', 'avatar', className)}
          />
        )}
        {renderSender()}
        {!isLeft && from && from.photo && (
          <Avatar
            alt={renderSender()}
            src={`${Conf.assetsRoot}${from.photo}`}
            className={classNames('chat', 'avatar', className)}
          />
        )}
      </div>
      {!isEditing && <div className={classNames('chat', 'body', className)}>{renderTextWithLink(body)}</div>}
      {isEditing && (
        <input
          ref={editInput}
          type="text"
          value={bodyEdition}
          onChange={e => setBodyEdition(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleValidate()}
        />
      )}
      {renderActions()}
    </div>
  );
};

export default ChatMessage;
